import { styled } from "@material-ui/core/styles";
import { observer } from "mobx-react";
import * as React from "react";
import Markdown, { Justification } from "../coreui/Markdown";
import PaneRow, { WidgetValue } from "../models/PaneRow";
import { AccessLevel, ValueByBreakpoint } from "./Api";

interface ConfigProperties {
  dataId: string;
  justification: ValueByBreakpoint<Justification>;
  name: string;
}

interface RuntimeProperties {
  accessLevel: AccessLevel;
  textValue: string;
}

const MaxWidthDiv = styled("div")(({ theme }) => ({
  [theme.breakpoints.up("md")]: {
    maxWidth: "600px",
  },
  [theme.breakpoints.up("lg")]: {
    maxWidth: "580px",
  },
}));

export const MarkdownDisplay = observer(
  (props: ConfigProperties): JSX.Element | null => {
    const row = PaneRow.get(props.dataId);
    if (row === null) {
      return null;
    }

    const widget = row.getWidgetT<WidgetValue, RuntimeProperties>(props.name);
    const runtimeProperties = widget.properties;

    if (
      !runtimeProperties ||
      runtimeProperties.accessLevel === AccessLevel.hidden
    ) {
      return null;
    }

    return (
      <MaxWidthDiv>
        <Markdown
          justification={props.justification}
          value={runtimeProperties.textValue}
        />
      </MaxWidthDiv>
    );
  }
);
